import Client from "@/repositories/Clients/AxiosClient";
import Config from "@/repositories/Clients/AxiosDefaultConfig";
import { e2eEncrypt } from "@/libs/crypto-js";
import axios from "axios";

const resource = `${Config.basePath}/translate`;
const CancelToken = axios.CancelToken;
let cancel;

export default {
    translate(payload) {
        cancel && cancel();
        return Client.get(`${resource}`, {
            params: payload,
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancel = c;
            }),
        });
    },
};
